module.exports = __webpack_public_path__ + "static/media/pic5.8f97969c.jpg";